import { metadata, SVOD_RAIL_BONUSES } from "lacinetek-common/src/metadata"

import { BlockTitle } from "components/subscription/block-title"
import { SliderRailBonus } from "components/subscription/rail-bonus"

export const Bonuses = ({ block }) => {
	const bonuses = block.children.items.filter(category => !!metadata(category, SVOD_RAIL_BONUSES))

	if (bonuses.length === 0) {
		return null
	}

	return bonuses.map((bonus, index) => {
		const parseIds = metadata(bonus, SVOD_RAIL_BONUSES).split(",")

		if (!parseIds.length > 0) {
			return null
		}

		return (
			<section key={`bonus-${index}`}>
				<BlockTitle block={bonus} rail />
				<SliderRailBonus bonusIds={parseIds} isOverlay />
			</section>
		)
	})
}
